export default __webpack_public_path__ + "static/media/kitchen4-afterD.ffe9fc4c.jpg";